import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Interceptor para agregar el token de autenticación a las solicitudes
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar y normalizar errores de respuesta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { config, response } = error;

    // Si no hay response (timeout, red, CORS), rechazar tal cual
    if (!response) {
      return Promise.reject({ status: 0, data: { message: error.message || 'Network error' } });
    }

    // Normalizar payload a objeto JSON
    const payload = (response.data && typeof response.data === 'object')
      ? response.data
      : { message: response.statusText || 'Error' };

    // Acciones por código
    if (response.status === 401 && config.url !== '/login') {
      sessionStorage.removeItem('auth_token');
      sessionStorage.removeItem('user_name');
      sessionStorage.removeItem('user_role');
      window.location.replace('/ticketagrovin/login');
    } else if (response.status === 403) {
      console.warn('No tienes permisos para realizar esta acción');
    } else if ([419].includes(response.status)) {
      sessionStorage.removeItem('auth_token');
      sessionStorage.removeItem('user_name');
      sessionStorage.removeItem('user_role');
      window.location.replace('/ticketagrovin/login');
    }

    // Rechazar con objeto normalizado para que el frontend maneje siempre JSON
    return Promise.reject({ status: response.status, data: payload });
  }
);

export default api;